var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCancelEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_cancel_edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.00080895,4.80893099 L0.975489589,7.83263245 C0.752332851,8.05578918 0.390524292,8.05578918 0.167367554,7.83263245 C-0.0557891845,7.60947571 -0.0557891845,7.24766715 0.167367554,7.02451041 L0.167367554,7.02451041 L3.19978135,4.00790338 C2.03180786,2.8399299 0.677727344,1.48584938 0.281612423,1.08973446 L0.167367554,0.975489589 C-0.0557891845,0.752332851 -0.0557891845,0.390524292 0.167367554,0.167367554 C0.390524292,-0.0557891845 0.752332851,-0.0557891845 0.975489589,0.167367554 L0.975489589,0.167367554 L4,3.192 L7.02451041,0.167367554 C7.22287196,-0.0309939914 7.53078556,-0.0530341631 7.753492,0.101247039 L7.83263245,0.167367554 C8.05578918,0.390524292 8.05578918,0.752332851 7.83263245,0.975489589 L7.83263245,0.975489589 L4.808,4 L7.83263245,7.02451041 C8.03099399,7.22287196 8.05303416,7.53078556 7.89875296,7.753492 L7.83263245,7.83263245 C7.60947571,8.05578918 7.24766715,8.05578918 7.02451041,7.83263245 C7.02451041,7.83263245 6.28989352,7.09801555 5.34826332,6.15638536 L4.30609523,5.11421727 C4.21049843,5.01862046 4.10827731,4.91639934 4.00080895,4.80893099 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_cancel_edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "checkbox_checked-copy-3",
    stroke: "#005082",
    fill: "#FFFFFF",
    x: 0.527777778,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cross-Copy-4",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#005082",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelEdit);
export default __webpack_public_path__ + "static/media/icon_cancel_edit.64f4c0637b83ca5b663324a2963c2f82.svg";
export { ForwardRef as ReactComponent };